
  <h2 mat-dialog-title class="signTitle">   
    <ng-container *ngIf="hasSignature">My Signature</ng-container>
    <ng-container *ngIf="!hasSignature">Adopt your signature</ng-container>
 
    <ng-container *ngIf="hasSignature">
      <button mat-flat-button class="addNewSignButton" color="primary" (click)="addNewSignature()" [disabled]="fiveSignaturesLimitReached"> 
      <mat-icon>add</mat-icon> Add signature 
    </button>
    </ng-container>
    <ng-container *ngIf="!hasSignature">
      <button mat-stroked-button class="addNewSignButton" color="primary" (click)="addNewSignature()" [disabled]="fiveSignaturesLimitReached"> 
      <mat-icon>arrow_back</mat-icon> Back 
      </button>
    </ng-container>

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <ng-container >

    <mat-dialog-content class="mat-typography">
      <div class="tabConainer">

        <ng-container *ngIf="!hasSignature" >
          <!-- new signature add options -->
        <div class="signatureOptions" >

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'draw'}" (click)="signatureType('draw')" >
            <div class="icon">
              <img src="./../../../assets/images/signature.png" alt="">
            </div>
            <div class="info">
              <h3>Draw your signature</h3>
              <p>Draw your signature here using your mouse or trackpad.</p>
            </div>
          </div>


          <div class="drawSignature" [ngClass]="{'active': signOpt == 'uploads'}" (click)="signatureType('upload')">
            <div class="icon">
              <img src="./../../../assets/images/uploadIcon.png" alt="">
            </div>
            <div class="info">
              <h3>Upload your signature</h3>
              <p>Upload an image on your handwritten signature here.</p>
            </div>
          </div>

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'type'}" (click)="signatureType('type')">
            <div class="icon">
              <img src="./../../../assets/images/typeIn.png" alt="">
            </div>
            <div class="info">
              <h3>Type in your signature</h3>
              <p>Add your name and select any font.</p>
            </div>
          </div>

        </div>
        <!-- new signature add options -->


        <!-- new signature Preview & Holder -->
        <div class="previewHolder">
          <h3 class="preview_text" >PREVIEW</h3>
        <div class="previewContainer">
          <ng-container *ngIf="signOpt == 'upload'">
            <div class="uploadholderSignature">
              <!-- <mat-icon>note_add</mat-icon> -->
              <img src="./../../../assets/images/uploadIcon.png" alt="" width="60" >
              <p *ngIf="filenameForSign == '' ">Upload your signature</p>
              <span *ngIf="filenameForSign == '' ">Upload an png image on your handwritten signature here</span>
              <p>{{filenameForSign}}</p>
              <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
                placeholder="Add file">
            </div>
          </ng-container>

          <ng-container *ngIf="signOpt == 'draw'">
            <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
              (onEndEvent)="drawComplete()"></signature-pad>
          </ng-container>

          <ng-container *ngIf="signOpt == 'type'">
            <div class="divideCol">
              <div class="left blk">
                <mat-form-field>
                  <mat-label>Enter Signature Name</mat-label>
                  <input matInput required placeholder="Enter signature name" value="" [(ngModel)]="signName"
                    (ngModelChange)="signOrInitialTextChanges($event)">
                </mat-form-field>
              </div>
              <div class="right blk">
                <mat-form-field appearance="fill">
                  <mat-label>Select font family</mat-label>
                  <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                    <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="allSign">
              <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                {{signName}}
              </div>
              <style>
                @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
              </style>
            </div>
          </ng-container>
        </div>
        </div>
        <!-- new signature Preview & Holder -->
        </ng-container>
        


        <div *ngIf="hasSignature" class="signatureListHolder">

          <span class="limitReached" *ngIf="fiveSignaturesLimitReached" >You can add upto 5 signatures only. Please delete a signature if you want to add new.</span>

          <div *ngFor="let img of getAllSignatures" class="signatureList">

            <div class="uploadedData"  (click)="selectedSignature(img)" [ngClass]="{ 'active': signatureID === img.signatureID || img.isDefault == true }">

              <mat-icon class="unselect">radio_button_unchecked</mat-icon>
              <mat-icon class="select">check_circle</mat-icon>

              <div class="sig-cell">
                <div class="sig-chrome">
                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                  <div class="sig-container">
                   
                    <ng-container *ngIf="img.signature.type=='Draw'">
                      <div class="signature">
                        <img [src]="img.signature.signatureBase64"/>
                      </div>
                    </ng-container>
      
                    <ng-container *ngIf="img.signature.type=='Upload'">
                      <div *ngFor="let img1 of img.signature.ImageData" class="signature">
                        <img [src]="img1.Imageurl"/>
                      </div>
                    </ng-container>
      
      
                    <ng-container *ngIf="img.signature.type=='Type In'">
                      <div class="signature">
                        <h3 [ngStyle]="{'font-family': img.signature.signInitialFontFamily}">
                          {{img.signature.signatureText}}</h3>
                      </div>
                    </ng-container>
                    
                  </div>
                  <div class="sig-chrome-title-bottom ng-binding">email id</div>
                </div>
              </div>

              <button mat-icon-button class="closeIcon" (click)="deleteSignature(img)"><mat-icon>close</mat-icon></button>
            </div>

          </div>
      </div>

      
       

      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <span>
        <button *ngIf="signOpt == 'draw' && !hasSignature" mat-stroked-button color="primary" (click)="clearSignature()">Clear</button>

        <!-- [disabled]="getAllSignatures.length==0" -->
        <button *ngIf="hasSignature" mat-flat-button (click)="addDefaultSignature()"   color="primary">Adopt &  Sign</button>

        <button *ngIf="!hasSignature" mat-flat-button (click)="addSignature()" color="primary" [disabled]="!SignButtonEnable">Adopt &  Sign</button>
      </span>
    </mat-dialog-actions>
  </ng-container>


  <app-loader></app-loader>